import { Autocomplete, Chip, TextField } from '@material-ui/core';
import React, { useEffect, useState } from "react";
import useAlerts from "../../../hooks/useAlerts";

const ArticleField = ({updateArticle, chips}) => {
  const [value, setValue] = useState(chips.map(e => e.name))
  const alert = useAlerts();

  useEffect(() => {
    let result = value.map(e => {
      return {
        id: null,
        article: e,
        isMain: false,
      }
    })

    updateArticle(result)
  }, [value])

  const updateValue = (newValue: string) => {
    if (newValue.length > 1) {
      if (value.indexOf(newValue) === -1) {
        setValue([...value, newValue])
      } else {
        alert({
            message: "Артикул уже добавлен",
            variant: "info",
            autoHideDuration: 5000
        });
      }
    }
  }

  const deleteChip = (newValue) => {
    if (value.length > 1) {
      setValue(value.filter(e => e != newValue))
    } else {
      alert({
          message: "Нельзя удалить последний артикул",
          variant: "error",
          autoHideDuration: 5000
      });
    }
  }
  
  const saveChipClipboard = (newValue: string) => {
    navigator.clipboard.writeText(newValue);
    alert({
      message: "Артикул скопирован в буфер обмена",
      variant: "info",
      autoHideDuration: 5000
    });
  }  
  
  return (
    <>
      <Autocomplete
        multiple
        options={[]}
        size={"small"}
        value={value}
        disableClearable
        onChange={(event, newValue) => {
          updateValue(event.target.value)
        }}
        onBlur={(event) => {
          updateValue(event.target.value)
        }}
        freeSolo
        renderTags={(value: readonly string[], getTagProps) => {
            return value.map((option: string, index: number) => (
              <Chip
                sx={{mr: 1}}
                variant="outlined" 
                onClick={(event) => saveChipClipboard(option)} 
                onDelete={() => {deleteChip(option)}} 
                label={option} 
                key={index} 
              />
            ))
          }          
        }
        renderInput={(params) => (
          <TextField
            {...params}
          />
        )}
      />
    </>
  )
}

export default ArticleField